// extracted by mini-css-extract-plugin
module.exports = {"exploreProviders":"OverviewPage_exploreProviders__3edZL","center":"OverviewPage_center__1MnEr","overviewSection":"OverviewPage_overviewSection__1kjuv"};